export const institutionSummary = {
  name: 'University of Lagos',
  campus: 'Akoka Main Campus',
  students: 42180,
  activeThisWeek: 31964,
  integrationLevel: 'Directory sync — academic records remain student-managed',
}

export const populationByFaculty = [
  { faculty: 'Engineering', students: 6120, engaged: 4810 },
  { faculty: 'Sciences', students: 7340, engaged: 5210 },
  { faculty: 'Social Sciences', students: 6890, engaged: 4402 },
  { faculty: 'Arts', students: 5210, engaged: 2915 },
  { faculty: 'Law', students: 2480, engaged: 1908 },
  { faculty: 'Business', students: 5980, engaged: 4188 },
  { faculty: 'Medicine', students: 3160, engaged: 2571 },
]

export const academicActivity = [
  { label: 'Courses registered this semester', value: '186,402', delta: '+4.2% vs last semester' },
  { label: 'Assignments tracked', value: '58,911', delta: '+11.8%' },
  { label: 'Attendance records logged', value: '412,088', delta: '+6.1%' },
  { label: 'Students below attendance threshold', value: '2,914', delta: '−0.8%' },
]

export const feedbackByCategory = [
  { category: 'Accommodation', open: 184, resolved: 402, medianDays: 9 },
  { category: 'Course delivery', open: 96, resolved: 611, medianDays: 5 },
  { category: 'Facilities', open: 143, resolved: 288, medianDays: 12 },
  { category: 'Campus services', open: 71, resolved: 204, medianDays: 7 },
  { category: 'Safety', open: 38, resolved: 129, medianDays: 3 },
]

export const recurringIssues = [
  { issue: 'Evening water supply in off-campus hostels', reports: 312, trend: 'Rising' },
  { issue: 'Oversubscribed computer laboratory sessions', reports: 188, trend: 'Rising' },
  { issue: 'Street lighting on Iwaya Road approach', reports: 141, trend: 'Steady' },
  { issue: 'Delayed result publication', reports: 96, trend: 'Falling' },
]

export const safetySnapshot = [
  { label: 'Incidents reported (30 days)', value: 74 },
  { label: 'Median time to assignment', value: '48 min' },
  { label: 'Alerts issued', value: 9 },
  { label: 'Anonymous reports', value: '41%' },
]

export const accommodationPressure = [
  { neighbourhood: 'Onike', demand: 1840, listedBeds: 620, medianRent: 620000 },
  { neighbourhood: 'Iwaya', demand: 1420, listedBeds: 410, medianRent: 580000 },
  { neighbourhood: 'Bariga', demand: 2210, listedBeds: 1180, medianRent: 300000 },
  { neighbourhood: 'Yaba', demand: 980, listedBeds: 340, medianRent: 690000 },
  { neighbourhood: 'Fadeyi', demand: 640, listedBeds: 420, medianRent: 430000 },
]

export const careerOutcomes = [
  { label: 'Students with career profiles', value: '18,402' },
  { label: 'Applications submitted', value: '9,118' },
  { label: 'Interviews reached', value: '2,206' },
  { label: 'Verified employers engaged', value: '184' },
]

export const engagementEvents = [
  { title: 'Engineering Week', registrations: 512, capacity: 800, organizer: 'Faculty of Engineering' },
  { title: 'Lagos Tech Careers Fair', registrations: 1187, capacity: 1500, organizer: 'Careers Unit' },
  { title: 'Inter-faculty football final', registrations: 2340, capacity: 4000, organizer: 'Sports Council' },
  { title: 'Mental health awareness week', registrations: 388, capacity: 600, organizer: 'Counselling Unit' },
]
